import './App.css';
import Balloons from './Games/Balloons';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './assets/Home'


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/balloons' element={<div className='flex flex-row flex-wrap h-[100vh]' style={{ justifyContent: 'center' }}><Balloons /></div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
